export default __webpack_public_path__ + "static/media/Albero.8ced1241.png";